import { Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { PlannerService } from '../api/planner.service';
import { LocalstorageService } from './localstorage.service';
import { FB_Template, USER_ID } from '@algomusinc/domain';
@Injectable({
  providedIn: 'root'
})
export class HelperService {
public PLANNER_CONFIG = {
  LABELS: {ItemLabel: '', AccountLabel: '', TimeFrameLabel: '', DistributorLabel: '', ForecastTimeFrame: ''},
  ITEMS: new Array(),
  ACCOUNTS: new Array(),
  CALENDAR: new Array(),
  ITEM_HIERARCHY: new Array(),
  ACCOUNT_HIERARCHY: new Array(),
  CALENDAR_HIERARCHY: new Array(),

  ITEM_HIERARCHY_DICTIONARY: {} as { [key: string]: any },
  ACCOUNT_HIERARCHY_DICTIONARY: {} as { [key: string]: any },
  CALENDAR_HIERARCHY_DICTIONARY: {} as { [key: string]: any },

  ACTIVE_COMBINATIONS: new Array(),
  ITEM_LEVELS: new Array(),
  ACCOUNT_LEVELS: new Array()
}
constructor(public config: ConfigurationService, public plannerService: PlannerService, public storage: LocalstorageService) { }
  public async setPlannerConfig(
    fbTemplateId: number,
    vendorOrDcId?: any,
    seasonCodes?: string | string[] | null,
    groups?: any,
    rangeType?: any,
    rangedOnly?: boolean
  ) {
    await this.setClientAlias().catch(err => new Error(err));
    await this.setCalendar().catch(err => new Error(err));
    await this.setAccounts().catch(err => new Error(err));
    // await this.setItems().catch(err => new Error(err));
    await this.setHierarchies(fbTemplateId, vendorOrDcId, seasonCodes, groups, rangeType, rangedOnly).catch(err => new Error(err));
  }
  public async setAccounts() {
    const params = {
      offset: 0,
      pageSize: 100000,
      active: true,
    };

    let url = `offSet=${params.offset ? params.offset : 0}&pageSize=${ params.pageSize ? params.pageSize : 10}&active=true`;

    if (this.PLANNER_CONFIG.ACCOUNTS.length == 0) {
      const accountRes = await firstValueFrom(this.config.ItemAccountGetAll(url));
      this.PLANNER_CONFIG.ACCOUNTS = accountRes.data || [];
    }
  }
  public async setItems() {
    const params = {
      offset: 0,
      pageSize: 100000,
      active: true,
    };

    let url = `offSet=${params.offset ? params.offset : 0}&pageSize=${ params.pageSize ? params.pageSize : 10}&active=true`;
    if (this.PLANNER_CONFIG.ITEMS.length == 0) {
      const itemRes = await firstValueFrom(this.config.ItemManagerGetAll(url));
      this.PLANNER_CONFIG.ITEMS = itemRes.data || [];
    }
  }
  public async setHierarchies(
    fbTemplateId: number,
    vendorOrDcId?: any,
    seasonCodes?: string | string[] | null,
    groups?: any,
    rangeType?: any,
    rangedOnly?: boolean
  ) {
    const tasks = new Array();
    const payloadForItemHierarchy: any = {
      fbTemplateId: fbTemplateId ,
      userId: this.storage.get(USER_ID),
      vendorIds: vendorOrDcId ? vendorOrDcId.vendorId : null,
      dcIds: vendorOrDcId ? vendorOrDcId.dcId : null,
      seasonCodes: (seasonCodes && seasonCodes.length > 0) ? seasonCodes : null,
      productGroupIds: groups? groups.productGroup : null,
      rangeType: !!rangeType ? rangeType : null,
    };
    if (typeof rangedOnly === 'boolean') {
      payloadForItemHierarchy.rangedOnly = rangedOnly;
    }
    if (
      !(fbTemplateId in this.PLANNER_CONFIG.ITEM_HIERARCHY_DICTIONARY) || 
      !(fbTemplateId in this.PLANNER_CONFIG.ACCOUNT_HIERARCHY_DICTIONARY) || 
      !(fbTemplateId in this.PLANNER_CONFIG.CALENDAR_HIERARCHY_DICTIONARY)) {
          // Hierarchy Not Loaded for Current Planner  
          if(fbTemplateId !== FB_Template.Customer_Order_Planner)
          {
            tasks.push(this.config.ItemHierarchyGetAllTree(payloadForItemHierarchy));
          }
          tasks.push(this.config.AccountHierarchyGetAllTree({fbTemplateId: fbTemplateId, userId: this.storage.get(USER_ID), storeGroupIds: groups? groups.storeGroup: null }))
          tasks.push(this.config.CalendarHierarchyGetAll({fbTemplateId: fbTemplateId}))
    }
    else if (vendorOrDcId)
    {
      const response = await firstValueFrom(this.config.ItemHierarchyGetAllTree(payloadForItemHierarchy))
      let _parsed = JSON.parse(response);
      this.PLANNER_CONFIG.ITEM_HIERARCHY_DICTIONARY[fbTemplateId] = _parsed;
    }

    const res: Array<string> | any = await firstValueFrom(forkJoin(tasks)).catch(error => new Error(error));
    if (res && res.length) {
      res.forEach((response: string, index: number) => {
        let _parsed = JSON.parse(response);
        if (fbTemplateId == FB_Template.Customer_Order_Planner) {
          this.PLANNER_CONFIG.ITEM_HIERARCHY_DICTIONARY[fbTemplateId] = []
          if (index == 0) {
            this.PLANNER_CONFIG.ACCOUNT_HIERARCHY_DICTIONARY[fbTemplateId] = _parsed;
          } else {
            this.PLANNER_CONFIG.CALENDAR_HIERARCHY_DICTIONARY[fbTemplateId] = _parsed;
          }
        } else {
          if (index == 0) {
            this.PLANNER_CONFIG.ITEM_HIERARCHY_DICTIONARY[fbTemplateId] = _parsed;
          } else if (index == 1) {
            this.PLANNER_CONFIG.ACCOUNT_HIERARCHY_DICTIONARY[fbTemplateId] = _parsed;
          } else {
            this.PLANNER_CONFIG.CALENDAR_HIERARCHY_DICTIONARY[fbTemplateId] = _parsed;
          }
        }
      })
    }
  }
  public async setClientAlias() {
    if (!(this.PLANNER_CONFIG.LABELS.ItemLabel)) {
      const labels = await firstValueFrom(this.config.GetClientAliasString({}));
      const parsedLabels = JSON.parse(labels);
      if (parsedLabels.ItemLabel) {
        this.PLANNER_CONFIG.LABELS = parsedLabels;
      }
    }
  }
  public async setCalendar() {
    const calendarRes: Array<any> = await firstValueFrom(this.plannerService.calendarGetList({}));
    this.PLANNER_CONFIG.CALENDAR = calendarRes;
  }
}
